export const pink = "#FFB0B7";
export const orange = "#FFA500";
export const green = "#70B6C1";
export const red = "#FF6B6B";
export const yellow = "#F3CC5C";
const gray = "#E6E9ED";

export const discountColor = pink;
export const exchangeColor = yellow;
export const exchangeCreditColor = orange;
export const refundColor = green;
export const unknownColor = gray;

export const waitingColor = pink;

export const acceptedColor = "#4CAF50"; // Green for accepted
export const rejectedColor = "#FF6B6B"; // Red for rejected
export const pendingColor = "#E6E9ED";  // Gray for pending
